import { render, staticRenderFns } from "./DBMLFFIntroduce.vue?vue&type=template&id=01c0230b&scoped=true&"
import script from "./DBMLFFIntroduce.vue?vue&type=script&lang=js&"
export * from "./DBMLFFIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./DBMLFFIntroduce.vue?vue&type=style&index=0&id=01c0230b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c0230b",
  null
  
)

export default component.exports